import React from 'react';
import styles from './style.module.scss';
import { useLocale } from '../../../../lib/hook';

interface QuestionNumberTextProps {
  current: number;
  total: number;
  isArrowVisible: boolean;
  isOptional: boolean;
}

const QuestionNumberText: React.FC<QuestionNumberTextProps> = ({
  current, total, isArrowVisible, isOptional,
}) => {

  const { t } = useLocale();
  return (
    <div
      className={`${styles['survey-question-text']} ${
        isArrowVisible ? styles['with-arrow'] : ''
      }`}
    >
      <span className={styles.number}>
        {t('component.questionNumber.questionNumberCurrent', { numberCurrent: current })}
      </span>
      <span className={styles.total}>
        {t('component.questionNumber.questionNumberMax', { numberMax: total })}
      </span>
      {isOptional && (
        <span className={styles.total}>
          {t('component.questionNumber.optional')}
        </span>
      )}

    </div>
  );

};

export default QuestionNumberText;
